import { doSchemaUpdate } from "../../actions/thunks/schemaThunks";
import { getAccessToken } from "../storage/accessTokenStorage";

const dispatchSchemaUpdate = (component, endpoint, payload, callback) => {
  const submitEndpoint = endpoint || component.props.submitEndpoint;
  const accessToken = component.props.accessToken || getAccessToken();
  component.props.dispatch(
    doSchemaUpdate({
      accessToken,
      endpoint: submitEndpoint,
      payload,
      navigate: component.props.navigate,
      callback,
    })
  );
};

export default dispatchSchemaUpdate;
